@if (config$ | async; as config) {
  <sh-dialog [style]="style" [open]="open$ | async" (closed)="closeModal()">
    <med-fragment-preview-dialog [config]="config" (closeModal)="closeModal()"></med-fragment-preview-dialog>
  </sh-dialog>
}
